import { notifyParent } from 'mailup-react-helpers'
import { useEffect } from 'react'

function useBeforeUnload(isDirty) {
  const handleBeforeUnload = (e) => {
    notifyParent('showLoadingMainFrame', [false])

    if (isDirty) {
      e.preventDefault()
      return (e.returnValue = '')
    } else {
      delete e.returnValue
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload, {
      capture: true
    })

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, {
        capture: true
      })
    }
  }, [isDirty])
}

export default useBeforeUnload
